// extracted by mini-css-extract-plugin
export default {"container":"IckG7e","quotesCard":"J9Wzst","lg":"BgYqOJ","accessibleDesktopContainer":"EW_J2N","cardMargin":"o0pkMQ"};